import moment from 'moment';
import { useState } from 'react';
import icon_pin from '../../../assets/images/pin.svg';
import icon_trash from '../../../assets/images/icon_trash.svg';
import icon_unpin from '../../../assets/images/unpin.svg';
import CustomModal from '../../../hoc/CustomModal';
import CustomTable from '../../../hoc/CustomTable';
import PopComponent from '../../popContent';
import icon_search from '../../../assets/images/icon_search.svg'
import { Tooltip } from "antd";
import { Form } from "antd";
import { useEffect } from 'react';

const PostPop = ({ search, setSearch, allPost, setDeletePostId, handleDeletePost, filteredPosts, filteredAdminPosts, loading, setPinState, post, handlePin }) => {

    const [modalName, setModalName] = useState("UserPop");
    const [openModal, setModalOpen] = useState(false);
    const [error, setError] = useState({});
    const [title, setTitle] = useState('')
    let Modal = PopComponent[modalName];
    const [form] = Form.useForm();

    useEffect(()=>{
        setSearch({ title: '' })
    },[])
    
    const handleOpenModal = (type, data) => {
        let flag = 0;
        switch (type) {
            case 'ErrorPop': {
                setModalName(type);
                setError(data)
                setModalOpen(true);
                break;
            }
            case 'AlertPost': {
                setPinState({ type: !data.pin ? "pin" : "unpin", postId: data.id, group_id: data.group_id, course_id:data?.course_id })
                flag = 1;
                break;
            }
            case 'DeletePost': {
                setDeletePostId(data.id);
                setModalName('DeletePostPop');
                setModalOpen(!openModal);
                break;
            }
            default: {
                setDeletePostId(null);
                setModalName(type);
                setModalOpen(!openModal);
                break;
            }
        }
        if (flag === 1) {
            setDeletePostId(null);
            setModalName(type);
            setModalOpen(!openModal);
        }
    };
    
    
    const columns = [
        {
            title: 'Post Title',
            dataIndex: 'name',
            type: 'custom',
            render: (data) => {
                
                let arr1 = data?.raw?.split('class="lightbox"');
                for (let i = 0; i < arr1?.length - 1; i++) {
                    arr1[i] = arr1[i] + 'class="lightbox" target="_blank"'
                }
                let arr = arr1?.join('')?.split('src');
                for (let i = 0; i < arr?.length - 1; i++) {
                    if (arr[i].includes('class="lightbox"'))
                        arr[i] = arr[i] + 'class="cursor_pointer" src'
                    else
                        arr[i] = arr[i] + 'onClick="window.open(this.src)" class="cursor_pointer" src'
                }
                return <td><pre dangerouslySetInnerHTML={{ __html: arr?.join("") }}></pre></td>
            }
        },
        {
            title: 'Post Date',
            dataIndex: 'post_date',
            sort: true,
            type: 'custom',
            render: (data) => {
                return <td>{moment(data.updated_at)?.format('MM/DD/YYYY')}</td>
            },
        },
        {
            title: 'Created By',
            dataIndex: 'created_by',
            filter: true,
            type: 'custom',
            render: (data) => {
                return <td>{data?.is_admin ? 'Admin' : '-'}</td>
            },
        },
        {
            title: 'Pin Status',
            dataIndex: 'pin_status',
            type: 'custom',
            render: (data) => (<td>{data.pin ? 'Y' : 'N'}</td>)
        },
        {
            title: 'Action',
            type: "action",
            ActionHeader: () => {
                return (
                    <td className="action_btn"><p></p></td>
                )
            },
            ActionContent: (data) => {
                return (
                    <td className="action">
                        <span><img onClick={() => handleOpenModal('AlertPost', data)} src={data.pin ? icon_pin : icon_unpin} alt="Post icon" height="14" /></span>
                        <span><img onClick={() => handleOpenModal('DeletePost', data)} src={icon_trash} alt="Post icon" height="14" /></span>
                    </td>
                )
            },
            dataIndex: '',
            key: 'x',
        },
    ];

    const myStyle = {
        maxWidth: '18.8rem',
        fontSize: '1.6rem',
        lineHeight: '1.9rem',
        letterSpacing: '.02em',
        color: '#000000',
    }

    return (
        <div className="group_icon_modal pin">
            <h1 className="text_uppercase">pin a topic</h1>
            <div className="d_flex justify_content_between fullWidth">
                <p style={myStyle}>{post.course_name}</p>

                <div className="pin_search d_flex">
                    <div className="pin_search_input flex_direction_column p_3 mb_3">
                        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} className="form_control" autoComplete='off' />
                        <span className="pin_search_icon"><img src={icon_search} alt="Search Icon" height="18" width="18" /></span>
                        <span onClick={() => { setSearch({ title: '' }); setTitle('') }} style={{ color: title && 'black' }} className="text_right clear_search_text cursor_pointer">Clear search results</span>
                    </div>
                    <span onClick={() => setSearch({ title: title })} className="pin_search_go_btn mb_3" >GO </span>
                </div>
            </div>
            <div className="fullWidth">
                <CustomTable
                    popContent={true}
                    tableData={allPost}
                    columns={columns}
                    loading={loading}
                    filteredAdminPosts={filteredAdminPosts}
                    filteredPosts={filteredPosts}
                    postTable={true}
                    className="courses_data_listing course_pin_modal"
                />
            </div>
            {Modal && (
                <CustomModal className={'ant-modal modal skill_model'} handleOpen={handleOpenModal} open={openModal}>
                    <Modal
                        error={error}
                        handlePin={handlePin}
                        handleOpenModal={handleOpenModal}
                        handleDeletePost={() => handleDeletePost(handleOpenModal)}
                    />
                </CustomModal>
            )
            }
        </div>
    )
};

export default PostPop